//mypreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#ECF5E6',
            100: '#DDECCD',
            200: '#C7E2AE',
            300: '#AFDA8E',
            400: '#92C26E',
            500: '#63A830',
            600: '#4D9127',
            700: '#3A7B1C',
            800: '#2A6513',
            900: '#006F43',
            950: '#0F3306'
        },
        danger: {
            50: '{red.50}',
            100: '{red.100}',
            200: '{red.200}',
            300: '{red.300}',
            400: '{red.400}',
            500: '{red.500}', // Color base para errores (rojo)
            600: '{red.600}',
            700: '{red.700}',
            800: '{red.800}',
            900: '{red.900}',
            950: '{red.950}'
        }
    },
    components: {
        tabs: {
            tab: {
                color: '#6b7280',
                hoverColor: '#374151',
                activeColor: '#16a34a',
                activeBorderColor: '#16a34a'
            },
            activeBar: {
                background: '#16a34a'
            }
        }
    }
});

export default MyPreset;